import { flexRender, HeaderGroup } from '@tanstack/react-table';
import type { ComparisonColumn } from './salesComparisonApi';
import type { ReportRow } from './salesComparisonTypes';
import { thBase, SEPARATOR_BORDER, separatorBorder } from './salesComparisonStyles';

interface Props {
    columns: ComparisonColumn[];
    headerGroups: HeaderGroup<ReportRow>[];
}

// Three header tiers: the comparable/non-comparable/grand-total group row, the gold-star row, and the
// per-column header row (rendered from TanStack's header groups).
export function ComparisonTableHeader({ columns, headerGroups }: Props) {
    const comparableCount = columns.filter(c => c.kind === 'comparableStore').length;
    const nonComparableCount = columns.filter(c => c.kind === 'nonComparableStore').length;
    const sep = (index: number) => separatorBorder(columns[index]?.separator);

    return (
        <thead>
            <tr>
                <th style={thBase} />
                {comparableCount > 0 && <th colSpan={comparableCount} style={{ ...thBase, textAlign: 'center', background: '#f5f3ff', color: '#4c1d95' }}>Jämförbara butiker</th>}
                <th style={{ ...thBase, textAlign: 'center', background: '#ede9fe', color: '#4c1d95', borderLeft: SEPARATOR_BORDER['s-ct'] }}>Σ Jmfb</th>
                {nonComparableCount > 0 && <>
                    <th colSpan={nonComparableCount} style={{ ...thBase, textAlign: 'center', background: '#fff7ed', color: '#9a3412', borderLeft: SEPARATOR_BORDER['s-nc'] }}>Ej jämförbara</th>
                    <th style={{ ...thBase, textAlign: 'center', background: '#fff7ed', color: '#9a3412', borderLeft: SEPARATOR_BORDER['s-nt'] }}>Σ Ny</th>
                </>}
                <th style={{ ...thBase, textAlign: 'center', background: '#f0fdf4', color: '#15803d', borderLeft: SEPARATOR_BORDER['s-gt'] }}>Grand Total</th>
            </tr>
            <tr>
                <th style={{ ...thBase, background: '#fffbeb' }} />
                {columns.map((c, i) => (
                    <th key={i} style={{ ...thBase, textAlign: 'center', background: '#fffbeb', letterSpacing: 2, borderLeft: sep(i) }}>{'⭐'.repeat(c.stars)}</th>
                ))}
            </tr>
            {headerGroups.map(headerGroup => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => {
                        const isLabel = header.column.id === 'label';
                        return (
                            <th key={header.id} style={{ ...thBase, background: '#fafafa', textAlign: isLabel ? 'left' : 'right', minWidth: isLabel ? 190 : undefined, position: isLabel ? 'sticky' : undefined, left: isLabel ? 0 : undefined, borderLeft: isLabel ? undefined : sep(Number(header.column.id.slice(1))) }}>
                                {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        );
                    })}
                </tr>
            ))}
        </thead>
    );
}
